// extracted by mini-css-extract-plugin
export default {"banner":"WithFixedBanner_banner__tcNIl","body":"WithFixedBanner_body__DmApA","container":"WithFixedBanner_container__1zXv3"};